import { HttpParams } from '@angular/common/http';
import { Component, ViewChild, OnInit } from '@angular/core';
import { DxDataGridComponent, DxDataGridTypes, } from 'devextreme-angular/ui/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom } from 'rxjs';
import { UsersService } from 'src/app/shared/services';
import { EventLogService } from 'src/app/shared/services/event-log-service';

@Component({
  selector: 'app-eventlog',
  templateUrl: './eventlog.component.html',
  styleUrls: ['./eventlog.component.scss'],
})
export class EventlogComponent implements OnInit {

  rules = { X: /[02-9]/ };
  @ViewChild(DxDataGridComponent, { static: true })
  dataGrid!: DxDataGridComponent;
  dataSource = {} as CustomStore
  users: any[] = []
  popupVisible:boolean = false;
  selectedEventLog: any;
  httpTypes: any[] = [{ id: 1, name: 'Post' }, { id: 2, name: 'Put' }, { id: 3, name: 'Delete' }, { id: 4, name: 'Patch' }, { id: 5, name: 'Patch' }]
  public categories: any[] = [{ id: 1, name: 'Smtp' }, { id: 2, name: 'Content' }, { id: 3, name: 'Settings' }, { id: 4, name: 'User' }, { id: 5, name: 'Exception' }, { id: 6, name: 'Sms' }]

  constructor(private eventLogService: EventLogService,
    private usersService: UsersService
  ) {
    this.eventLogService.getDataSource().then((dataSource) => { this.dataSource = dataSource; });
  }

  async ngOnInit(): Promise<void> {
    this.users = await firstValueFrom(this.usersService.getUsers())
  }

  getRowNumber(rowIndex: number): number {
    const pageIndex = this.dataGrid.instance.pageIndex(); // Mevcut sayfa numarası
    const pageSize = this.dataGrid.instance.pageSize(); // Sayfa başına kayıt sayısı
    return pageIndex * pageSize + rowIndex + 1;
  }
  rowClick(e: DxDataGridTypes.RowClickEvent) {
    this.selectedEventLog = e.data
    this.popupVisible = true;
  }

}
